import axios from "@axios";

const DEFAULT_STATE = {
  dates: [],
  eventTypes: [],
  events: [],
  projects: [],
  eventCategories: [],
  filteredEvents: [],
  eventTypesList: [],
  projectsList: [],
  eventCategoriesList: [],
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getDates: (state) => state.dates,
    getEventTypes: (state) => state.eventTypes,
    getEvents: (state) => state.events,
    getProjects: (state) => state.projects,
    getEventCategories: (state) => state.eventCategories,
    getFilteredEvents: (state) => state.filteredEvents,
    getEventTypesList: (state) => state.eventTypesList,
    getProjectsList: (state) => state.projectsList,
    getEventCategoriesList: (state) => state.eventCategoriesList,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setDates(state, payload) {
      state.dates = payload;
    },
    setEventTypes(state, payload) {
      state.eventTypes = payload;
    },
    setEvents(state, payload) {
      state.events = payload;
    },
    setProjects(state, payload) {
      state.projects = payload;
    },
    setEventCategories(state, payload) {
      state.eventCategories = payload;
    },
    setFilteredEvents(state, payload) {
      state.filteredEvents = payload;
    },
    setEventTypesList(state, payload) {
      state.eventTypesList = payload;
    },
    setProjectsList(state, payload) {
      state.projectsList = payload;
    },
    setEventCategoriesList(state, payload) {
      state.eventCategoriesList = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateDates({ commit }, payload) {
      commit("setDates", payload);
    },
    updateEventTypes({ commit }, payload) {
      commit("setEventTypes", payload);
    },
    updateEvents({ commit }, payload) {
      commit("setEvents", payload);
    },
    updateProjects({ commit }, payload) {
      commit("setProjects", payload);
    },
    updateEventCategories({ commit }, payload) {
      commit("setEventCategories", payload);
    },
    updateFilteredEvents({ commit }, payload) {
      commit("setFilteredEvents", payload);
    },
    async updateEventTypesList({ commit }, payload) {
      const url = "/rmra-event-types/";
      const options = {
        params: {
          projects: payload.join(","),
        },
      };
      const response = await axios.get(url, options);
      commit("setEventTypesList", response.data.items);
    },
    async updateProjectsList({ commit }) {
      const url = "/rmra-projects/";
      const response = await axios.get(url);
      commit("setProjectsList", response.data.items);
    },
    async updateEventCategoriesList({ commit }) {
      const url = "/rmra-event-categories/";
      const response = await axios.get(url);
      commit("setEventCategoriesList", response.data.items);
    },
  },
};
